import * as React from "react"
import { format } from "date-fns/format"
import { parse } from "date-fns/parse"
import { isValid } from "date-fns/isValid"
import { CalendarIcon } from "lucide-react"
import { cn } from "../../lib/utils"
import { Button } from "./button"
import { Calendar } from "./calendar"
import { Popover, PopoverContent, PopoverTrigger } from "./popover"
import { Input } from "./input"

function DatePicker({ value, onChange, placeholder = "DD/MM/AAAA", className, testId }) {
  const [open, setOpen] = React.useState(false)

  const selectedDate = (() => {
    if (!value) return undefined
    const parsed = parse(value, "dd/MM/yyyy", new Date())
    return isValid(parsed) ? parsed : undefined
  })()

  const handleSelect = (date) => {
    if (date) {
      onChange(format(date, "dd/MM/yyyy"))
    } else {
      onChange("")
    }
    setOpen(false)
  }

  const handleInputChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 8)
    const parts = []
    if (digits.length > 0) parts.push(digits.substring(0, 2))
    if (digits.length > 2) parts.push(digits.substring(2, 4))
    if (digits.length > 4) parts.push(digits.substring(4, 8))
    onChange(parts.join("/"))
  }

  return (
    <div className={cn("flex", className)}>
      <Input
        type="text"
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        maxLength={10}
        className="rounded-r-none"
        data-testid={testId}
      />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className="rounded-l-none border-l-0 px-3"
            type="button"
          >
            <CalendarIcon className="h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar
            mode="single"
            selected={selectedDate}
            onSelect={handleSelect}
            initialFocus
            defaultMonth={selectedDate || undefined}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}

export { DatePicker }
